import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import OrderSearchSection from './components/OrderSearchSection';
import {useSearchParams} from "react-router-dom";
import {searchOrderRequest} from "../../store/order/actions/order-actions";

const OrderSearchPage = () => {

    const {searchResults} = useSelector((state) => state.orderData);
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();

    const rawPage = parseInt(searchParams.get('page')) || 0;
    const size = parseInt(searchParams.get('size')) || 10;

    const page = rawPage; // send 0-based to backend

    const handlePageChange = ({ page, size }) => {
        setSearchParams({ page: String(page), size: String(size) });
    };

    useEffect(() => {
        const hasPage = searchParams.has('page');
        const hasSize = searchParams.has('size');

        if (!hasPage || !hasSize) {
            setSearchParams({
                page: hasPage ? searchParams.get('page') : '0',
                size: hasSize ? searchParams.get('size') : '10',
            });
        }
    }, []);

    return (
        <div className="container mx-auto p-4">
            <OrderSearchSection data = {searchResults}
                                searchResults={searchResults?.value ? searchResults.value : []}
                                page={rawPage}
                                size={size}
                                handlePageChange={handlePageChange}
            />
            <br/>
        </div>
    );
};

export default React.memo(OrderSearchPage);
